module.exports = __webpack_public_path__ + "img/V-63-ST-1000-BE.5ddb075f.png";